export function Background() {
  return (
    <>
      <div className="grain" aria-hidden="true" />
      <div className="aurora" aria-hidden="true">
        <span className="aurora__one" />
        <span className="aurora__two" />
        <span className="aurora__three" />
      </div>
      <div className="vortex-bg" aria-hidden="true">
        <svg viewBox="0 0 800 800" preserveAspectRatio="xMidYMid meet">
          <defs>
            <linearGradient id="ring-grad" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#5EEAD4" stopOpacity="0.6" />
              <stop offset="55%" stopColor="#22D3EE" stopOpacity="0.35" />
              <stop offset="100%" stopColor="#0EA5E9" stopOpacity="0" />
            </linearGradient>
          </defs>
          <g className="vortex-ring vortex-ring--1" style={{ transformOrigin: "400px 400px" }}>
            <circle
              cx="400"
              cy="400"
              r="320"
              fill="none"
              stroke="url(#ring-grad)"
              strokeWidth="1"
              strokeDasharray="3 14"
            />
          </g>
          <g className="vortex-ring vortex-ring--2" style={{ transformOrigin: "400px 400px" }}>
            <circle
              cx="400"
              cy="400"
              r="260"
              fill="none"
              stroke="url(#ring-grad)"
              strokeWidth="1.2"
              strokeDasharray="2 22"
            />
          </g>
          <g className="vortex-ring vortex-ring--3" style={{ transformOrigin: "400px 400px" }}>
            <circle
              cx="400"
              cy="400"
              r="200"
              fill="none"
              stroke="url(#ring-grad)"
              strokeWidth="0.8"
              strokeDasharray="1 9"
            />
          </g>
        </svg>
      </div>
    </>
  );
}
